import { render } from "./ResultReferred.vue?vue&type=template&id=cc835422&ts=true"
import script from "./ResultReferred.vue?vue&type=script&lang=ts"
export * from "./ResultReferred.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__